import { useContext } from 'react'

import ApiCallStoreContext from 'contexts/ApiCallStoreContext'

const useApiCallStore = () => useContext(ApiCallStoreContext)

export default useApiCallStore
